import { useDispatch, useSelector } from 'react-redux';
import { selectSalesMan } from '@store/partners-registration/selectors';
import { setSalesMan } from '@store/partners-registration/slice';
import Checkbox from '@components/checkbox/Checkbox';



enum SalesManEnum {
	plachy = 'Daniel Plachý',
	none = 'nemám svého OZ',
}


const SalesManInfo = (): JSX.Element => {

	const salesMan = useSelector(selectSalesMan);
	const dispatch = useDispatch();
	const updateSalesMan = (value: string | null) => dispatch(setSalesMan(value));

	return (
		<div className='salesman-info-section'>

			<label className='salesman-label'>
				Vyberte svého obchodního zástupce
			</label>

			<Checkbox isSelected={salesMan === SalesManEnum.plachy} onChange={() => updateSalesMan(SalesManEnum.plachy)}>
				Daniel Plachý
			</Checkbox>

			<Checkbox isSelected={salesMan === SalesManEnum.none} onChange={() => updateSalesMan(SalesManEnum.none)}>
				nemám svého OZ
			</Checkbox>

		</div>
	);
};

export default SalesManInfo;